import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ButtonsBar from '../../components/buttons-bar/buttons-bar';
import Empty from '../../components/empty/empty';
import ErrorComponent from '../../components/error/error';
import FeatureTitle from '../../components/feature-title/feature-title';
import List from '../../components/list/list';
import Loading from '../../components/loading/loading';
import SubmitButton from '../../components/submit-button/submit-button';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerFormat,
} from '../../models/base-content-container';

// Helpers
import { classroomsToLabel } from '../../helpers/announcement-helper';
import { dueOnToLabel } from '../../helpers/activity-helper';

// Services
import ActivityService from '../../services/activity-service';
import SchoolService from '../../services/school-service';
import StorageService from '../../services/storage-service';

const ActivityList = () => {
  const titles: ListContentTitle[] = [
    { text: 'Título' },
    { text: 'Turmas' },
    { text: 'Data de envio', align: 'right' },
    { text: 'Data de entrega', align: 'right' },
    { text: 'Visualizados', align: 'right' },
    { text: 'Feitas', align: 'right' },
  ];

  const [error, setError] = useState(false);
  const [activityList, setActivityList] = useState<ListContent[]>(null);
  useEffect(() => {
    const schoolService = new SchoolService();
    const storageService = new StorageService();
    const schoolId = storageService.getEmployee().schoolId;

    schoolService
      .getSchoolById(schoolId)
      .then((school) => new ActivityService(school.uuid).listAllBackoffice())
      .then((items) => {
        const newActivityList: ListContent[] = items.map((item) => ({
          linkTo: `/atividades/${item.id}`,
          data: [
            {
              text: item.title,
              customStyle: { maxWidth: '250px' },
            },
            {
              text: classroomsToLabel(item.classrooms),
            },
            {
              text: format(parseISO((item.scheduledAt ?? item.createdAt).local), 'dd/MM/yyyy'),
              subText: item.isScheduled ? 'Agendada' : null,
              align: 'right',
            },
            {
              text: dueOnToLabel(item.dueOn),
              align: 'right',
            },
            {
              text: `${item.seenRecipients}/${item.totalRecipients}`,
              align: 'right',
            },
            {
              text: `${item.doneRecipients}/${item.totalRecipients}`,
              align: 'right',
            },
          ],
        }));

        setActivityList(newActivityList);
      })
      .catch(() => setError(true));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <ErrorComponent type='contentFull' />;

  if (!activityList) return <Loading type='contentFull' />;

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.singleWithActionButtons}
      actionButtonPosition={BaseContentContainerActionButtonPosition.top}
    >
      <ButtonsBar pattern='firstSeparate'>
        <FeatureTitle title='atividades' />
        <Link to='/atividades/criar'>
          <SubmitButton value='criar nova atividade' variant='primary' />
        </Link>
      </ButtonsBar>

      {activityList.length > 0 ? (
        <List titles={titles} contents={activityList} />
      ) : (
        <Empty />
      )}
    </BaseContentContainer>
  );
};

export default ActivityList;
